import { Component, inject, model } from '@angular/core';
import { PermissionsService } from '../services/permissions.service';
import { ProfileService } from '../../profile/services/profile.service';
import { ActivatedRoute } from '@angular/router';
import { PermissionsModel } from '../../shared/models/permissions.model';
import { PermissionsFormComponent } from "../permissions-form/permissions-form.component";
import { AccessService } from '../../core/services/access.service';

@Component({
  selector: 'app-permissions-details',
  standalone: true,
  imports: [PermissionsFormComponent],
  templateUrl: './permissions-details.component.html',
  styleUrl: './permissions-details.component.css'
})
export class PermissionsDetailsComponent {
  private service = inject(PermissionsService)
  private route = inject(ActivatedRoute)

  protected access = inject(AccessService).access

  id!: string | null;

  value = model<PermissionsModel | undefined>(undefined)

  ngOnInit(): void {
    this.service.title.update((value) => 'Detalles del Permiso')
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.getValue(params.get('id'));
    });
  }

  getValue(id: string | null) {
    if (id === null) {
      this.value.update((value) => (value = undefined));
    } else {
      this.service.get(id).subscribe((data) => {
        this.value.update(value => {
          value = data as PermissionsModel
          // console.log('permissions: ', value);
          return value;
        });
      });
    }
  }
}
